import { DateTime, Interval } from "luxon";
import { DateWithoutTime } from "./DateWithoutTime.js";

/** Both dates are inclusive. Second date must be greater than or equal to first date. */
export type DateRange = [DateWithoutTime, DateWithoutTime];

export function isDateRange(value: unknown): value is DateRange {
  return (
    Array.isArray(value) &&
    value.length === 2 &&
    value.every((v) => v instanceof DateWithoutTime) &&
    value[0] <= value[1]
  );
}

export function isValidInterval(value: unknown): value is Interval {
  return Interval.isInterval(value) && value.isValid;
}

export function dateRangeContains(dateRange: DateRange, event: { start: DateTime; end: DateTime }): boolean {
  const dateRangeStart = dateRange[0].toDateTime();
  if (event.end <= dateRangeStart) {
    return false;
  }
  const dateRangeEnd = dateRange[1].nextDay.toDateTime();
  return event.start < dateRangeEnd;
}
